import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Typography} from '@mui/material';
import {APIError} from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({


  cardContent: {
    margin: '10px 15px 10px 15px',
    height: 'calc(100% - 70px)'
  },
  multiCountContent: {
    display: 'flex',
    flexWrap: "wrap",
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    width: '100%',
    // height: '100%',
  },
  multiCountItem: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: "wrap",
    flexGrow: 4,
    // flexBasis: 0,
    flexShrink: 1,
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    // width: "calc(100%-50px)",
    height: '100%',
    cursor: 'pointer'
  },
  caption: {
    // borderBottom: '1px solid #ccc',
    display: 'flex',
    margin: '10px 15px 10px 15px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    // minHeight: 120,
    // fontSize: '1.0rem',
    width: '100%',
    height: '30%',
    cursor: 'pointer'
},
  countContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    // minHeight: 120,
    // fontSize: '3.0rem',
    width: '100%',
    height: '70%',
    cursor: 'pointer'
  },
  contentContainer: {
    display: 'flex',
    flexWrap: "wrap",
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    // height: '100%',
  },

});

interface Props {
  id: number;
  renderers: any;
  element: any;

  chromeless?: boolean;

  elementType: any;

  inEditMode?: boolean;

}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
};

class MultiCountRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      data: null
    };
  }

  // UNSAFE_componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

 componentDidMount() {
    const self = this;
    if (!this.props.element || !this.props.element.id) {
      console.error("No ID found on Props")
    } else {
   
    request
      .get('/api/dashboards/' + this.props.element.id)
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        self.setState({status: 'ready', data: response.body});
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          self.setState({status: 'ready', error: apiErr});
        }
      });
    }
  }

  static register = () => {
   
    if(!Renderers.find("MultiCountElementRenderer")){
     
      Renderers.register("MultiCountElementRenderer", withStyles(styles)(MultiCountRenderer))
    }
  }

  onCountClick = (idx:any) => (evt:any) => {
    
    const {data} = this.state;
   
    if (
      data &&
      data.element.fulfillmentCriteria &&
      data.element.fulfillmentCriteria.counts &&
      data.element.fulfillmentCriteria.counts[idx] &&
      data.element.elementAttributes &&
      data.element.elementAttributes.targetURL
    ) {
      const reducedForm = this.reduceCriteria(data.element.fulfillmentCriteria.counts[idx]);

      var url: string = data.element.elementAttributes.targetURL;
      var crit = data.element.fulfillmentCriteria.counts[idx];
      delete crit.criteriaForm;
      delete crit.resultsForm;
      url += '?q=' + URLManager.getQueryStringValue(crit);
      window.location.href = url;
    }
  };

  reduceCriteria = (crit: any) => {
   
    delete crit['criteriaForm'];
    delete crit['resultsForm'];
  };

  getThresholdAttributes = (): any => {
    const {data} = this.state;

    let attr = {};
   

    if (
      data.element.elementAttributes &&
      data.element.elementAttributes.thresholds
    ) {
      const thresholds = data.element.elementAttributes.thresholds;
     

      if (thresholds.defaultAttributes) {
        attr = thresholds.defaultAttributes;
      }
      if (thresholds.entries) {
        var sorted = thresholds.entries.sort((a, b) => {
          return a.value > b.value;
        });

        for (let i of sorted) {
          if (i.floorValue <= data.content.count && i.attributes) {
            attr = i.attributes;
          }
        }
      }
    }

    return attr;
  };

  renderCount = (
    count: any,
    idx: number
  ) => {
    const {classes}: {classes: ClassNameMap} = this.props;
    const styleAttributes = this.getThresholdAttributes();
   
    return (
      <div key={"count_"+idx} className={classes.multiCountItem} onClick={this.onCountClick(idx)}>
        <Typography className={classes.caption} variant="subtitle1">
        <label >{count.label}</label>
        </Typography>
        <div
        // onClick={this.onCountClick(idx)}
        className={classes.countContent}
        style={styleAttributes}>
        {count.count}
        </div>
      </div>
        
    );
  };
  

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless, renderers} = this.props;
    const {status, data} = this.state;

    var cardContent: any = null;
   
    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView compact classes={{}} />
          </div>
        );

      default:
        if (data && data.element && data.element.elementType) {
          const styleAttributes = this.getThresholdAttributes();

          var renderer: any = null;
         
          cardContent = (
            <div
              className={classes.multiCountContent}
              style={styleAttributes}>
              {data.content.innterContents.map((count: any, index: number) => {
                return this.renderCount(
                count,
                index
                );})}
            </div>
          );
        }
    }


    return  <div className={classes.contentContainer}>{cardContent}</div>; 
  }
}

export default withStyles(styles)(MultiCountRenderer);

